// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { AxiosError } from 'axios';
import { ofType } from 'redux-observable';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ActionType, getType } from 'typesafe-actions';

import { getChallengeReviews } from '../../apis/challenge';
import { LoadingType } from '../../types/Common';
import { getChallengeReviewsActions } from '../actionCreators/getChallengeReviewsActions';
import { RootAction } from '../rootActionCreator';

const outputActions = {
  success: getChallengeReviewsActions.success,
  failure: getChallengeReviewsActions.failure
};

type RequestActionTypes = ActionType<
  typeof getChallengeReviewsActions.request
>;
type OutputActionTypes = ActionType<typeof outputActions>;

export const getChallengeReviewsEpic = (
  action$: Observable<RootAction>
): Observable<OutputActionTypes> => {
  return action$.pipe(
    ofType(
      // action filter
      getType(getChallengeReviewsActions.request)
    ),
    switchMap((action: RequestActionTypes) => {
      // prepare api params
      const { id, loadingType = LoadingType.NEW, condition } = action.payload;
      // send api promise
      return getChallengeReviews(id, condition)
        .then((response: any) => {
          // handle success case here
          return getChallengeReviewsActions.success({
            ChallengeReviewsStatistics: response.data.data,
            ChallengeReviewsList: response.data.list,
            id,
            loadingType
          });
        })
        .catch((error: AxiosError) => {
          // handle error case here
          return getChallengeReviewsActions.failure({ error });
        });
    })
  );
};
